module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h2",
    attrs: {
      "id": "page_xii"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_xiii"
    }
  }), _c('a', {
    attrs: {
      "id": "ack"
    }
  }), _vm._v("Acknowledgements")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("There are many people who helped Len with his book. Harry Greene, Lynne Houck, Jim Hopson, Keith Thomson, John Bolt, George Lauder, and Mike LaBarbera all read early versions of various chapters. Their comments and criticisms were greatly appreciated. Jack Sepkoski, Philip Gingerich, Jacques Gauthier, Jim Hopson, Eric Lombard, and George Lauder contributed comments and data for figures. Discussions with Martin Feder, George Lauder, Jim Hopson, and Eric Lombard were particularly helpful to me. Dennis Green did a wonderful job of translating Len’s ideas and sketches into finished figures. Ruth Bachman compiled the glossary and helped read proof.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Susan Abrams took a special interest in Len’s book from the beginning. Her strong emotional and professional support are largely responsible for the book’s completion. Finally, Len would certainly have wanted to acknowledge the love and encouragement of his friends. And so, a special thanks to Lynne Houck, Steve Arnold, Harry Greene, Kristine Tollestrup, Jeanne and Stuart Altmann, Susan and Brock Cole, Steve Gould, Ann Sakai, Steve Weller, Brigid Hogan, Martha McClintock, Pam Parker, and Wim Weijs.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt",
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v("Sharon Emerson")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6cdea809","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/9780226220635_06_ack.vue
// module id = 78
// module chunks = 0